import React, { Component } from "react";
import { Paper, FlatButton, MenuItem, Subheader, Divider } from "material-ui";
import { FormsyText, FormsySelect } from "formsy-material-ui/lib";
import Loading from "../Loading";
import PreviewClientNag from "./PreviewClientNag";
import Formsy from "formsy-react";
import FormsyDate from "../forms/formComponents/FormsyDate";
import formatDate from "../../../utils/formatDate";
import getDateTime from "../../../utils/getDateTime";

export default class ProcessClientNag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      clientNag: {},
      template: {},
      client: {},
      attachments: [],
      documents: [],
      statusSelections: [
        { label: "Verified", value: "verified" },
        { label: "Pending", value: "pending" },
        { label: "On Hold", value: "on hold" },
      ],
      statusSelection: "",
      emailList: [],
      emailSelection: "",
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "66%",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
      },
    };

    this.getClientNag = this.getClientNag.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.updateClientNag = this.updateClientNag.bind(this);
    this.handleEmailSelection = this.handleEmailSelection.bind(this);
    this.openSendOndatePicker = this.openSendOndatePicker.bind(this);
  }

  componentWillMount() {
    this.getClientNag(this.props.params._id);
  }

  notifyFormError(data, info1, info2) {
    console.error("Form error:", data, info1, info2);
    alert("Could not save form, miss filling out any fields?");
  }

  submitForm(data) {
    data.id = this.state.clientNag._id;
    this.updateClientNag(data).then((json) => {
      this.getClientNag(json.uid__c);
      alert("Communication Updated");
      this.props.performRoute.bind(
        this,
        `/job/communicationsManager/massEmailer/pending/`,
      );
    });
  }

  getClientNag(id) {
    this.getClientNagRecord(id).then((clientNag) => {
      this.getEmailList(clientNag.client.client_guid__c).then((emailList) => {
        this.setState({
          isLoading: false,
          clientNag: clientNag,
          date: clientNag.date ? new Date(clientNag.date) : {},
          client: clientNag.client,
          emailList: emailList,
          emailSelection: clientNag.email ? clientNag.email : "",
          template: clientNag.template,
          attachments: clientNag.attachment,
          documents: clientNag.document.map((doc) => {
            return { name: doc };
          }),
        });
      });
    });
  }

  getClientNagRecord(id) {
    return new Promise((resolve, reject) => {
      let url = `/api/email/getClientNag?id=${id}`;
      let options = {
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          resolve(json);
        });
    });
  }

  getEmailList(guid) {
    return new Promise((resolve, reject) => {
      let url = `/api/email/cchEmailList?clientGuid=${guid}`;
      let options = {
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          resolve(json);
        });
    });
  }

  updateClientNag(data) {
    return new Promise((resolve, reject) => {
      let url = "/api/email/updateClientNag";
      let options = {
        method: "PUT",
        headers: {
          token: this.props.token.jwt,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((id) => {
          resolve(id);
        });
    });
  }

  handleEmailSelection(e, val) {
    this.setState({ emailSelection: val });
  }

  renderSent(sentObj, i) {
    let d = new Date(sentObj.date);
    return (
      <p>
        {i + 1}: {getDateTime(d, d)} {sentObj.email ? ", " + sentObj.email : ""}
      </p>
    );
  }

  renderEmailSelection(selection, i) {
    if (selection.EmailAddress.length > 0) {
      return (
        <MenuItem
          key={i}
          primaryText={selection.EmailType + " - " + selection.EmailAddress}
          value={selection.EmailAddress}
        />
      );
    }
  }

  openSendOndatePicker(e) {
    this._sendOnDatePicker.focus();
  }

  render() {
    let { clientNag, client, template, attachments, documents } = this.state;
    let { centerStyle } = this.state.styles;
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
        >
          <div style={centerStyle}>
            <h1 style={{ marginBottom: "1em" }}>View Client Communication</h1>
          </div>
          <Formsy.Form
            ref="form"
            onValidSubmit={this.submitForm.bind(this)}
            onInvalidSubmit={this.notifyFormError}
          >
            <Divider />
            <Subheader>Update Records</Subheader>
            <div style={centerStyle}>
              <FlatButton
                label="Edit Client Info"
                onClick={this.props.performRoute.bind(
                  this,
                  `/job/salesForceClients/ClientEditor/${client._id}`,
                )}
              />
              <FlatButton
                label="Edit Template"
                onClick={this.props.performRoute.bind(
                  this,
                  `/job/communicationsManager/documentTemplates/${template._id}`,
                )}
              />
              <FlatButton
                label="Refresh"
                onClick={this.getClientNag.bind(this, clientNag._id)}
              />
            </div>
            <Divider />
            <Subheader>Communication Info</Subheader>
            <div style={centerStyle}>
              <FormsyText
                fullWidth
                readOnly
                name="status"
                floatingLabelText="Status"
                value={clientNag.status}
              />
              {clientNag.status === "recurring" && (
                <div>
                  <FormsyText
                    fullWidth
                    readOnly
                    name="attempt"
                    floatingLabelText="Attempt Count"
                    value={clientNag.attempt.toString()}
                  />
                  <FormsyText
                    fullWidth
                    readOnly
                    name="interval"
                    floatingLabelText="Attempt Interval (days)"
                    value={clientNag.interval.toString()}
                  />
                </div>
              )}
              {clientNag.status === "pending" && (
                <div>
                  <FormsyDate
                    fullWidth
                    autoOk
                    required
                    hideCalendarDate
                    container="inline"
                    name="date"
                    firstDayOfWeek={0}
                    value={this.state.date}
                    formatDate={(date) => formatDate(date)}
                    floatingLabelText="Send On Date"
                    textFieldStyle={{ cursor: "pointer" }}
                  />
                  <FormsySelect
                    fullWidth
                    name="email"
                    floatingLabelText="Choose Email"
                    value={this.state.emailSelection}
                    onChange={this.handleEmailSelection}
                  >
                    {this.state.emailList.map(this.renderEmailSelection)}
                  </FormsySelect>
                </div>
              )}
            </div>
            <Divider />
            <Subheader>Client Info</Subheader>
            <div style={centerStyle}>
              <FormsyText
                fullWidth
                readOnly
                name="clientId"
                floatingLabelText="Client ID"
                value={client.uid__c}
              />
              <FormsyText
                fullWidth
                readOnly
                name="name"
                floatingLabelText="Full Name"
                value={client.name}
              />
            </div>
            <Divider />
            <Subheader>Template Info</Subheader>
            <div style={centerStyle}>
              <FormsyText
                fullWidth
                readOnly
                name="templateName"
                floatingLabelText="Template Name"
                value={template.name}
              />
            </div>
            <Divider />
            {(clientNag.sent && clientNag.sent.length) > 0 && (
              <div>
                <Subheader>Sent History</Subheader>
                <div style={centerStyle}>
                  {clientNag.sent.map((sentObj, i) =>
                    this.renderSent(sentObj, i),
                  )}
                </div>
                <Divider />
              </div>
            )}
            <Subheader>Email Contents</Subheader>
            <div style={centerStyle}>
              <PreviewClientNag
                client={client}
                template={template}
                attachments={attachments}
                documents={documents}
              />
            </div>
            {clientNag.status === "pending" && (
              <div>
                <Divider />
                <br />
                <div style={centerStyle}>
                  <FlatButton
                    type="submit"
                    label="Update Communication"
                    hoverColor="#BDBDBD"
                  />
                </div>
              </div>
            )}
          </Formsy.Form>
        </Paper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/Email/ProcessClientNag.js